/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Yes
 * 
 * 1 = No
 * 
 * 2 = NA
 */
export enum YesNoNa {
  Yes = 0,
  No = 1,
  NA = 2
}
